/**
 * 取缓存
 * @param {*} name
 * @returns
 */
export function getLocalStorage(name) {
  try {
    var rtv = localStorage.getItem(name);
    if (/^[{[]/.test(rtv)) {
      return JSON.parse(rtv);
    }
    return rtv;
  } catch {
    return "";
  }
}
/**
 * 存缓存
 * @param {*} name
 * @param {*} val
 * @returns
 */
export function setLocalStorage(name, val) {
  try {
    if (typeof val === "object" && val !== null) {
      val = JSON.stringify(val);
    }
    localStorage.setItem(name, val);
  } catch {
    return "";
  }
}
/**
 * 解析网址
 * @param {*} url
 * @returns
 */
export function parseUrl(url) {
  var search = decodeURI(url),
    qsArr;
  if (search && (qsArr = /^\?(([^&#]+&?)+)/.exec(search))) {
    return qsArr[1].split("&").reduce(function(qs, q) {
      q = q.split("=");
      if (q[0]) qs[q[0]] = q[1];
      return qs;
    }, {});
  }
  return {};
}

/**
 * 获取URL中某个参数值
 * @param {String} url
 * @param {String} name
 * @returns
 */
export function getQueryString(url, name) {
  if (!url) return "";
  const newUrl = new URL(url);
  return newUrl.searchParams.get(name) || "";
}

/**
 * 获取URL参数值
 * @param {*} url
 * @returns
 */
export function parseQueryString(url) {
  var obj = {};
  var keyvalue = [];
  var key = "",
    value = "";
  var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
  for (var i in paraString) {
    keyvalue = paraString[i].split("=");
    key = keyvalue[0];
    value = keyvalue[1];
    obj[key] = value;
  }
  return obj;
}
/**
 * GA埋点
 * @param {String} act 事件名
 * @param {String} label
 */
export function gtag(act, label) {
  window.gtag("event", act, {
    event_category: "plamstore-h5",
    event_label: label
  });
}
/**
 * 客户端埋点
 * @param {String} str 事件名
 */
export function gtagApp(params) {
  console.log('params :>> ', params);
  if (window.android && window.android.callNative) {
    window.android.callNative('athenaTrack', JSON.stringify(params))
  }
  
  // str = `${str}_plamstore-h5`;
  // if (window.android && window.android.onTrackClick) {
  //   window.android.onTrackClick(str);
  // }

}

export function newGuid() {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
  }
  return guid;
}

export function daysBetween(DateOne, DateTwo) {
  var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
  var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf("-") + 1);
  var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

  var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
  var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf("-") + 1);
  var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));
  var cha =
    (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) -
      Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) /
    86400000;
  return cha;
}
